import {
  Component,
  Input
} from '@angular/core';


export class SkyWaitPageComponent {

  
  public hasBlockingWait: boolean;

  
  public hasNonBlockingWait: boolean;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-wait-page',
  template: `<div class="sky-wait-page">
  <sky-wait  [isWaiting]="hasNonBlockingWait" isFullPage="true" isNonBlocking="true">
  </sky-wait>
  <sky-wait [isWaiting]="hasBlockingWait" isFullPage="true">
  </sky-wait>
</div>
`,
  styles: [`.sky-wait-page /deep/ .sky-wait-mask-loading-fixed {
  z-index: 2000;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'hasBlockingWait': [{ type: Input },],
'hasNonBlockingWait': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
